import { useQuery } from 'hooks/useCustomQuery';
import getCompanyServicesWithSRT from 'API/SRT/getCompanyServicesWithSRT';

/**
 * Services deployed on the current company.
 *
 * Shared by the trunks table, which uses it to decide whether a trunk can be
 * added at all, and the add page, which uses it to decide whether the customer
 * has a choice of SBCaaS variant to make. The query key is deliberately the
 * same in both so they share one fetch.
 *
 * @param {object}  params
 * @param {string}  params.companyID
 * @param {boolean} [params.enabled]
 */
const useGetCompanyServices = ({ companyID, enabled = true } = {}) =>
    useQuery({
        queryKey: ['companyServices'],
        queryFn: async () => {
            const res = await getCompanyServicesWithSRT(companyID);
            return res.data;
        },
        enabled: Boolean(companyID) && enabled,
    });

export default useGetCompanyServices;
